import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = ({ authentication }) => ({
    auth: authentication,
});

const AuthorizedRoute = (props) => {
    const { component: Component, auth = {}, ...rest } = props;

    return (
        <Route
            {...rest}
            render={(propsAux) =>
                auth.authenticated ? <Component {...propsAux} /> : <Redirect to="/auth/login" />
            }
        />
    );
};

AuthorizedRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    auth: PropTypes.shape({}),
};

export default connect(mapStateToProps)(AuthorizedRoute);
